import { Form, Modal, ModalBody, ModalHeader } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../../../slices/common/reducer";
import "../Order.scss";
import { useState } from "react";
import { CopyIcon } from "../../../../assets/images/svg/svg";
import { getSendOrderLink } from "../OrderService";

const RedirectUrlModal = () => {
  const dispatch = useDispatch();
  const modalShow = useSelector((state) => state.common.modalShow);
  const redirectUrl = useSelector(
    (state) => state.order.selectedOrders.redirectUrl
  );

  const entityId = useSelector(
    (state) => state.order.selectedOrders.detailsData.entityid
  );

  const [copySuccess, setCopySuccess] = useState("");

  const handleClose = () => {
    dispatch(openModal(false));
  };

  // const handleCopy = () => {
  //   if (redirectUrl) {
  //     navigator.clipboard
  //       .writeText(redirectUrl)
  //       .then(() => {
  //         setCopySuccess("Copied!");
  //         setTimeout(() => setCopySuccess(""), 2000);
  //       })
  //       .catch((err) => {
  //         console.error("Failed to copy: ", err);
  //         setCopySuccess("Failed to copy");
  //       });
  //   }
  // };

  const handleCopy = () => {
    if (redirectUrl) {
      const tempInput = document.createElement("input");
      tempInput.value = redirectUrl;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      setCopySuccess("Copied!");
      setTimeout(() => setCopySuccess(""), 2000);
    }
  };

  const handleSend = () => {
    if (entityId) {
      getSendOrderLink(entityId);
    }
  };

  return (
    <Modal
      isOpen={modalShow}
      onHide={handleClose}
      centered
      className="border-0"
      modalClassName="modal fade zoomIn"
      toggle={handleClose}
    >
      <Form className="tablelist-form">
        <ModalHeader className="p-3 bg-info-subtle" toggle={handleClose}>
          Order Link
        </ModalHeader>
        <ModalBody className="modal-body">
          <div className="textarea-container-wrapper">
            <textarea
              className="textarea-container"
              value={redirectUrl || ""}
              readOnly
              disabled
            />
            <span className="copy-btn" onClick={handleCopy} title={copySuccess}>
              <CopyIcon />
            </span>
            {copySuccess && <div className="copy-message">{copySuccess}</div>}
          </div>
          <div className="button-wrapper">
            <button
              type="button"
              className="btn btn-outline-primary cancel"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className=" btn btn-primary save"
              onClick={handleSend}
            >
              Send
            </button>
          </div>
        </ModalBody>
      </Form>
    </Modal>
  );
};

export default RedirectUrlModal;
